import { useEffect, useRef, useState } from "react";
import HeaderIcon from "../../imgs/svgs/menu_header.svg";
import { basename } from "../../utils/Url";
import useWindowDimensions, {
  mobileSize,
  tabletSize,
} from "../../utils/WindowDimensions";

export const SideMenuButton = ({ currentUrl }) => {
  const [open, setOpen] = useState(false);
  const { width } = useWindowDimensions();
  const ref = useRef(null);
  const screenSize = width < mobileSize || width < tabletSize ? "50%" : "15%";

  window.onmessage = (e) => {
    if (e.data === "close") {
      setOpen(false);
    }
  };

  const handleClick = () => {
    setOpen((oldState) => !oldState);
  };

  const validateUrl = (url) => {
    return !url.includes(window.location.host);
  };

  useEffect(() => {
    if (open && ref !== null && ref.current !== null) {
      ref.current.focus();
    }
  }, [ref, open]);

  return (
    <>
      {currentUrl && validateUrl(currentUrl) ? (
        <>
          <img
            onClick={handleClick}
            style={{ width: "50px", height: "50px", cursor: "pointer" }}
            src={HeaderIcon}
            alt="Menu"
          />
          <div id="div-iframe" style={{ height: "100%" }}>
            <iframe
              id="iframe"
              title="side-menu"
              height="100%"
              width={screenSize}
              style={{
                zIndex: 100,
                position: "fixed",
                left: 0,
                top: 0,
                overflowY: "hidden",
                boxShadow: "0px 5px 12px #00000029",
                animationName: "menuAnimationIn",
                animationDuration: "0.3s",
              }}
              src={`${currentUrl}${basename.slice(
                1,
              )}/side_menu/?original_name=organograma`}
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-popups-to-escape-sandbox"
              frameBorder="0"
              allowFullScreen
              hidden={!open}
              ref={ref}
              onBlur={() => setOpen(false)}
            />
          </div>
        </>
      ) : null}
    </>
  );
};
